/**
 * @file 证件类型列表
 * @author qinliuye
 */

export const legalPersonTypeList = [
    {
        name: '居民身份证',
        value: 1
    }, {
        name: '居民户口簿',
        value: 2
    }, {
        name: '外国护照',
        value: 3
    }, {
        name: '军官证',
        value: 5
    }, {
        name: '士兵证',
        value: 6
    }, {
        name: '武警军官证',
        value: 7
    }, {
        name: '港澳居民来往内地通行证（香港）',
        value: 8
    }, {
        name: '台湾居民来往大陆通行证',
        value: 9
    }, {
        name: '临时居民身份证',
        value: 10
    }, {
        name: '外国人居留证',
        value: 11
    }, {
        name: '中国护照',
        value: 12
    }, {
        name: '武警士兵证',
        value: 13
    }, {
        name: '港澳居民来往内地通行证（澳门）',
        value: 14
    }, {
        name: '边民出入境通行证',
        value: 15
    }, {
        name: '台湾居民旅行证',
        value: 16
    }, {
        name: '其他个人证',
        value: 99
    }
]
export const supplierTypeSelectList = [
    {
        value: 1,
        label: '企业',
        disabled: false,
    },
    {
        value: 2,
        label: '个体工商户',
        disabled: false,
    },
    {
        value: 3,
        label: '小微商家',
        disabled: true,
    },
    {
        value: 4,
        label: '事业单位',
        disabled: true,
    },
    {
        value: 5,
        label: '政府机关',
        disabled: true,
    },
    {
        value: '6',
        label: '社会组织',
        disabled: true,
    }
]
export const overSeaSupplierTypeSelectList = [
    {
        value: 1,
        label: '企业',
        disabled: false,
    },
    {
        value: 2,
        label: '个体工商户',
        disabled: false,
    },
    {
        value: 3,
        label: '小微商户',
        disabled: false,
    },
    {
        value: 4,
        label: '境外商户',
        disabled: false,
    }
]
export const superAdminTypeSelectList =  [
    {
        value: 65,
        label: '法人',
        disabled: false,
    },
    {
        value: 66,
        label: '经办人',
        disabled: false,
    },
]
export const benefitTypeList =  [
    {
        value: 1,
        label: '法人',
        disabled: false,
    },
    {
        value: 0,
        label: '其它受益人',
        disabled: false,
    },
]
export const splitTypeSelectList = [
    {
        value: '1',
        label: '按比例',
        disabled: false,
    },
    {
        value: '2',
        label: '按金额',
        disabled: false,
    },
]

export const capitalSettlementTypeList = [
    {
        value: 1,
        label: 'T+1',
        disabled: false,
    },
    {
        value: 7,
        label: 'T+7',
        disabled: false,
    },
    {
        value: 14,
        label: 'T+14',
        disabled: false,
    },
    {
        value: 28,
        label: 'T+28',
        disabled: false,
    }
]




// 旧的
export const acctTypeListV2 = [
    {
        name: '企业对公户',
        value: '01'
    }
]
export const currencyList = [
    {
        name: '元（人民币）',
        value: 'CNY'
    }, {
        name: '港元',
        value: 'HKD'
    },
    {
        name: '新台币',
        value: 'EUR'
    }, {
        name: '欧元',
        value: 'HKD'
    },
    {
        name: '美元',
        value: 'USD'
    }, {
        name: '英镑',
        value: 'GBP'
    }, {
        name: '日元',
        value: 'JPY'
    }
]
export const regcapcurcode = {
    392: 'JPY',
    840: 'USD',
    826: 'GBP',
    156: 'CNY',
    978: 'HKD',
    954: 'HKD',
    901: 'EUR',  
}
// 商户分类
export const mchtTypeList = [
    {
        name: '企业商户',
        value: 1
    }, {
        name: '个体工商户',
        value: 2
    }
]
export const occupationTypeList = [
    {
        name: '国家机关、党群组织、企业、事业单位负责人',
        value: 0
    }, {
        name: '专业技术人员',
        value: 1
    }, {
        name: '办事人员和有关人员',
        value: 3
    },
    {
        name: '商业、服务业人员',
        value: 4
    }, {
        name: '农、林、牧、渔、水利业生产人员',
        value: 5
    }, {
        name: '生产、运输设备操作人员及有关人员',
        value: 6
    }, {
        name: '军人',
        value:'X'
    }
]

export const bankAccountTypeSelectList =  [
    {
        value: 74,
        label: '企业对公账户',
        disabled: false,
    },
    {
        value: 75,
        label: '法人对私账户',
        disabled: false,
    },
]

// 提现服务设置

// 接入方式
export const  withdrawAppTypeList=  [
    {
        value: 2,
        label: '预算提现',
        disabled: false,
    }
]

// 提现服务管理类型
export const  withdrawServiceTypeList=  [
    {
        value: 0,
        label: '托管型',
        disabled: false,
    },
    {
        value: 1,
        label: '半托管型',
        disabled: false,
    }
]

// 提现服务渠道类型
export const  withdrawServiceChannelTypeList=  [
    {
        value: 0,
        label: '支付宝',
        disabled: false,
    },
    {
        value: 1,
        label: '微信',
        disabled: false,
    },
    {
        value: 2,
        label: '银行卡',
        disabled: false,
    }
]

// 报警频次
export const alarmFreqList = [
    {
        value: 1,
        label: '1h/次',
        disabled: false,
    },
    {
        value: 2,
        label: '2h/次',
        disabled: false,
    },
    {
        value: 3,
        label: '3h/次',
        disabled: false,
    },
    {
        value: 4,
        label: '4h/次',
        disabled: false,
    },
    {
        value: 5,
        label: '5h/次',
        disabled: false,
    },
    {
        value: 6,
        label: '6h/次',
        disabled: false,
    },
    {
        value: 7,
        label: '7h/次',
        disabled: false,
    },
    {
        value: 8,
        label: '8h/次',
        disabled: false,
    },
    {
        value: 9,
        label: '9h/次',
        disabled: false,
    },
]
